import { useMemo } from 'react';

import { formatDateIso } from '../../dateTime';

import { useChannelPrograms } from './useChannelPrograms';
import { searchLiveProgram } from './utils';

export type UseChannelLiveProgramProps = {
  channelId: number;
  enabled?: boolean;
  timestamp: number;
};

export type UseChannelLiveProgramResult = ReturnType<typeof useChannelLiveProgram>;

export function useChannelLiveProgram({ channelId, enabled = true, timestamp }: UseChannelLiveProgramProps) {
  const { programs, error } = useChannelPrograms({ channelId, enabled, day: formatDateIso(timestamp) });

  const liveProgram = useMemo(() => {
    if (!programs) {
      return;
    }

    return searchLiveProgram(programs);
    // need to evaluate once timestamp changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programs, timestamp]);

  return {
    error,
    liveProgram,
  };
}
